import { useState, useEffect } from 'react';
import BrandCard from './BrandCard';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomeBrand(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { title, prods, langs, isLocal } = props;
  const [mainL, setMainL] = useState('en-US');

  let rows = JSON.parse(localStorage.getItem('machine'))?.themeColor?.b_row;

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
  }, []);

  let brands = JSON.parse(localStorage.getItem('brand'))
    ? JSON.parse(localStorage.getItem('brand'))
    : [];

  if (rows?.length > 0) {
    const index = rows * 3;
    if (brands?.length >= index) {
      brands = brands.slice(0, index);
    }
  }

  const result = brands.map((prod) => {
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    // const logo = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.logo}/${prod.referTo}`;
    const logo = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${prod.logo}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.logo}/${prod.referTo}`;
    return <BrandCard key={prod._id} langs={langs} prod={prod} image={url} logo={logo} />;
  });

  const allBrandPage = () => {
    history.push(`/machineUI/category/brand/allBrand/all`);
  };

  return (
    <div className="homeProduct" style={{ marginBottom: '30px' }}>
      <h1 className="homeProductText">{t(`Shop By Brand`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      <div className="home-brand-div">{result}</div>
      <div className="view-more-button " onClick={allBrandPage}>
        {t('VIEW MORE')}
      </div>
    </div>
  );
}
export default HomeBrand;
